<div class="display-flex align-items-flex-end">
  @if (messageType === 'received') {
    <sb-profile-photo
      class="flex-shrink-0 mb-1 mr-2@r"
      [class.visually-hidden]="!photoUrl"
      [photoUrl]="photoUrl"
      [size]="'sm'"
    />
  }

  <ng-content />
</div>
